import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import LinearProgress from "@mui/material/LinearProgress";

export function StripeWrapper({ public_key, children, options = undefined }) {
  const [stripeObject, setStripeObject] = useState(null);

  // This function will re-run if the public_key prop changes.
  useEffect(() => {
    const fetchStripeObject = async () => {
      // If there is no public_key, do not run the loadStripe function.
      if (public_key) {
        const res = await loadStripe(public_key);
        // When we have got the Stripe object, pass it into our useState.
        setStripeObject(res);
      }
    };
    fetchStripeObject();
  }, [public_key]);

  // If no Stripe object, do not render the Stripe Element.
  if (!stripeObject)
    return <LinearProgress />

  // Once we have the Stripe object, load everything.
  return <Box sx={{ margin: 0, width: '100%' }}>
    <Elements key={public_key} stripe={stripeObject} options={options}>
      {children}
    </Elements>
  </Box>
}
